(() => {
  const openBtn = document.querySelector('.js-product-filter-btn');
  const drawer = document.querySelector('.l-side.product-list-sidebar__wrapper.js-product-filter');
  const closeBtn = document.querySelector('.js-product-filter-close');

  if (!openBtn || !drawer || !closeBtn) return;

  const open = () => {
    drawer.classList.add('is-open');
  };

  const close = () => {
    drawer.classList.remove('is-open');
  };

  openBtn.addEventListener('click', (e) => {
    e.preventDefault();
    open();
  });

  closeBtn.addEventListener('click', (e) => {
    e.preventDefault();
    close();
  });


  drawer.addEventListener('click', (e) => {
    if (e.target === drawer) close();
  });


  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close();
  });
})();